import React from 'react';
import TeacherCard, { Img, DescriptionContainer, StyledTypography } from './styles';
import { Typography } from '@material-ui/core';
import LabelTitle from '../../Titles/LabelTitle';
import { useTranslation } from 'react-i18next';

const Teacher = ({ name, label, descriptions, image, imagePosition, imageSize }) => {
	const { t } = useTranslation();

	const getDescriptions = () => {
		return descriptions.map((record, idx) => (
			<Typography className="card-description" variant="body1" key={idx}>
				{t(record)}
			</Typography>
		));
	};

	return (
		<TeacherCard>
			<Img src={image} position={imagePosition} size={imageSize} />
			<DescriptionContainer>
				<StyledTypography variant="h1">{name}</StyledTypography>
				<LabelTitle content={label} />
				{getDescriptions()}
			</DescriptionContainer>
		</TeacherCard>
	);
};

export default Teacher;
